import { PaymentMethod } from 'drycut-graphql';

type Props = {
  manual: boolean;
  amount: number;
};

type UsePaymentMethodResult = {
  paymentMethod: PaymentMethod;
  isPaymentSkipped: boolean;
};

export default function usePaymentMethod({ manual, amount }: Props): UsePaymentMethodResult {
  let paymentMethod: PaymentMethod = PaymentMethod.Unk;

  if (manual) {
    paymentMethod = PaymentMethod.Direct;
  }

  // A coupon code was used so the amount to pay is 0, we should not show the Datatrans lightbox
  if (amount === 0) {
    paymentMethod = PaymentMethod.Skip;
  }

  // If it's a manual booking or the amount is 0, we skip the payment step
  const isPaymentSkipped =
    paymentMethod === PaymentMethod.Skip || paymentMethod === PaymentMethod.Direct;

  return { paymentMethod, isPaymentSkipped };
}
